import React from 'react';

// Loan terms shown on the Add/Edit Account form for loan accounts.
// Inputs are named so the form's FormData picks them up as-is.
const day = (v) => (v ? String(v).slice(0, 10) : '');

export default function LoanTermsFields({ account }) {
  const a = account || {};
  const box = 'w-full border rounded px-3 py-2';
  return (
    <fieldset className="border rounded p-3 space-y-3">
      <legend className="text-sm font-medium px-1">Loan terms</legend>
      <div className="grid grid-cols-2 gap-3">
        <label className="text-sm">Start date
          <input type="date" name="loan_start_date" defaultValue={day(a.loan_start_date)} className={box} />
        </label>
        <label className="text-sm">Term (months)
          <input type="number" min="1" max="600" step="1" name="loan_term_months" defaultValue={a.loan_term_months ?? ''} className={box} />
        </label>
        <label className="text-sm">Original amount
          <input type="number" min="0" step="0.01" name="loan_original_amount" defaultValue={a.loan_original_amount ?? ''} className={box} />
        </label>
        <label className="text-sm">Payment amount
          <input type="number" min="0" step="0.01" name="loan_payment_amount" defaultValue={a.loan_payment_amount ?? ''} className={box} />
        </label>
        <label className="text-sm">Payment frequency
          <select name="loan_payment_frequency" defaultValue={a.loan_payment_frequency || 'monthly'} className={box}>
            <option value="monthly">Monthly</option>
            <option value="biweekly">Every 2 weeks</option>
            <option value="weekly">Weekly</option>
            <option value="quarterly">Quarterly</option>
            <option value="annually">Yearly</option>
          </select>
        </label>
        <label className="text-sm">Maturity date
          <input type="date" name="loan_maturity_date" defaultValue={day(a.loan_maturity_date)} className={box} placeholder="Start + term" />
        </label>
      </div>
      <p className="text-xs text-gray-500">Leave maturity blank to calculate it from the start date and term.</p>
    </fieldset>
  );
}
